import { Fragment, useState, useEffect } from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
import ProofCards from "./ProofCards";
import "@styles/base/pages/app-ecommerce.scss";
import { Link } from "react-router-dom";
import { Upload } from "react-feather";

const Proof = (props) => {
  const {
    data,
    transactionCourseUser,
    transactionPaymentProofs,
    payment,
    dispatch,
    activeView,
    setActiveView,
    getCourses,
    stepper,
    setBlock,
    disabledDelete,
    setDisabledDelete,
  } = props;

  return (
    <div className="">
      {payment.transactionPaymentProofs &&
      payment.transactionPaymentProofs.length > 0 ? (
        <Fragment>
          <ProofCards
            data={data}
            setBlock={setBlock}
            payment={payment}
            dispatch={dispatch}
            activeView={activeView}
            setActiveView={setActiveView}
            getCourses={getCourses}
            transactionPaymentProofs={transactionPaymentProofs}
            disabledDelete={disabledDelete}
            setDisabledDelete={setDisabledDelete}
          />
        </Fragment>
      ) : (
        <div className="d-flex justify-content-center mt-2">
          <p>ไม่พบข้อมูล</p>
        </div>
      )}
    </div>
  );
};

export default Proof;
